import { alpha, Autocomplete, Box, Card, Divider, Drawer, Grid, List, ListItemText, MenuItem, Stack, styled, TextField, Tooltip } from '@mui/material';
import { useLocation, matchPath, Link } from 'react-router-dom';
// import menuItems, { MenuItem1 } from './items';
import { v4 as uuidv4 } from 'uuid';
import NavigationMenuItem from './item';
import { Popover, Button, Typography } from '@mui/material';
import Userbox from "./Userbox";
import MenuTwoToneIcon from "@mui/icons-material/MenuTwoTone";
import CloseTwoToneIcon from "@mui/icons-material/CloseTwoTone";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy';
import { IconButton, Badge } from "@mui/material";
import EventIcon from '@mui/icons-material/Event';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import ListAltIcon from '@mui/icons-material/ListAlt';
import BiotechIcon from '@mui/icons-material/Biotech';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PreviewIcon from '@mui/icons-material/Preview';
import FolderIcon from "@mui/icons-material/Folder";
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import SupportIcon from '@mui/icons-material/Support';
import PregnantWomanIcon from '@mui/icons-material/PregnantWoman';
import ReceiptIcon from '@mui/icons-material/Receipt';
import MasksIcon from '@mui/icons-material/Masks';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import HomeIcon from '@mui/icons-material/Home';
import FeedbackIcon from '@mui/icons-material/Feedback';
import MedicationIcon from '@mui/icons-material/Medication';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import InventoryIcon from '@mui/icons-material/Inventory';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import PostAddIcon from '@mui/icons-material/PostAdd';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import FolderDeleteIcon from '@mui/icons-material/FolderDelete';
import DescriptionIcon from '@mui/icons-material/Description';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { t } from "i18next";
import { useBottomBar } from "../../../contexts/BottomButtonsContext";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useTheme } from "@emotion/react";
import KeyboardArrowDownTwoToneIcon from "@mui/icons-material/KeyboardArrowDownTwoTone";
import ChevronRightTwoToneIcon from "@mui/icons-material/ChevronRightTwoTone";
import Text from "src/components/Text";
import AccountTreeTwoToneIcon from "@mui/icons-material/AccountTreeTwoTone";
import PeopleOutlineTwoToneIcon from "@mui/icons-material/PeopleOutlineTwoTone";
import DashboardCustomizeTwoToneIcon from "@mui/icons-material/DashboardCustomizeTwoTone";
import ContactSupportTwoToneIcon from "@mui/icons-material/ContactSupportTwoTone";
import ThemeSettings from 'src/components/ThemeSettings';
import React, { useEffect, useRef, useState } from 'react';
import {
  CardActionAreaWrapper, DotLegend, IconButtonPrimary, MenuListWrapperError,
  MenuListWrapperInfo,
  MenuListWrapperSecondary, MenuListWrapperSuccess
} from '..';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import BarChartIcon from '@mui/icons-material/BarChart';
import SummarizeIcon from '@mui/icons-material/Summarize';
import { Client, ComponentIcon, NavigationMenuGroup } from '../../../DashboardApi/api';
import { MenuItems } from './items';
import { useIconNavigation } from '../../../contexts/NavigationContext'
import { REACT_APP_PORTAL_API_URL } from '../../../../KeyVariables';
import { useAuthContext } from '../../../contexts/AuthContext';
const MenuWrapper = styled(Box)(
  () => `
  .MuiList-root {
    padding: 0;
    display: flex;
    flex-direction: column;
    align-items: center;

    & > .MuiList-root {
      display: flex;
      flex-direction: row;
    }
  }
`
);

const SubMenuWrapper = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      padding: 0;
      display: flex;
      flex-direction: row;
      
      .MuiList-root .MuiList-root .MuiListItem-root .MuiIconButton-root {
        font-weight: normal !important;
      }

      .MuiListItem-root {
        padding: 0 2px;
        justify-content: center;
    
        .MuiIconButton-root {
          display: flex;
          background-color: transparent;
          width: 58px;
          border-radius: ${theme.general.borderRadiusLg};
          height: 58px;
          justify-content: center;
          font-size: ${theme.typography.pxToRem(13)};
          padding: 0;
          position: relative;

          .name-wrapper {
            display: none;
            transition: ${theme.transitions.create(['color'])};
          }

          .MuiBadge-root {
            position: absolute;
            right: 8px;
            top: 12px;

            .MuiBadge-standard {
              background: ${theme.colors.alpha.white[70]};
              font-size: ${theme.typography.pxToRem(11)};
              font-weight: bold;
              text-transform: uppercase;
              color: ${theme.colors.alpha.black[100]};
            }
          }
  
          .MuiSvgIcon-root {
            transition: ${theme.transitions.create(['color'])};
            font-size: ${theme.typography.pxToRem(32)};
            color: ${theme.colors.alpha.trueWhite[70]};
          }

          &.active,
          &:hover {
            background-color: ${theme.colors.alpha.trueWhite[10]};

            .MuiSvgIcon-root {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }
      }
    }
`
);
const DrawerWrapper = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    width: "50vw", // Уменьшаем ширину для мобильных
    backgroundColor: alpha(theme.colors.primary.main, 0.95),
    backdropFilter: "blur(3px)",
    color: theme.header.textColor,
    padding: theme.spacing(2),
  },
}));

const MobileMenuButton = styled(Button)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: "40px",
  height: "40px",
  backgroundColor: alpha(theme.colors.primary.main, 0.95),
  color: theme.header.textColor,
}));

const iconMap = {
  AdminPanelSettingsIcon: AdminPanelSettingsIcon,
  PersonIcon: PersonIcon,
  EventIcon: EventIcon,
  LocalPharmacyIcon: LocalPharmacyIcon,
  BiotechIcon: BiotechIcon,
  FolderSharedIcon: FolderSharedIcon,
  VerifiedUserIcon: VerifiedUserIcon,
  PreviewIcon: PreviewIcon,
  ListAltIcon: ListAltIcon,
  BarChartIcon: BarChartIcon,
  MonitorHeartIcon: MonitorHeartIcon,
  FolderCopyIcon: FolderCopyIcon,
  VaccinesIcon: VaccinesIcon,
  PregnantWomanIcon: PregnantWomanIcon,
  ReceiptIcon: ReceiptIcon,
  MasksIcon: MasksIcon,
  MedicalServicesIcon: MedicalServicesIcon,
  HomeIcon: HomeIcon,
  FeedbackIcon: FeedbackIcon,
  MedicationIcon: MedicationIcon,
  ChildFriendlyIcon: ChildFriendlyIcon,
  InventoryIcon: InventoryIcon,
  MoveDownIcon: MoveDownIcon,
  PostAddIcon: PostAddIcon,
  CompareArrowsIcon: CompareArrowsIcon,
  FolderDeleteIcon: FolderDeleteIcon,
  DescriptionIcon: DescriptionIcon,
  AssignmentIcon: AssignmentIcon,
  ShoppingCartIcon:ShoppingCartIcon,
  QueryStatsIcon:QueryStatsIcon,
  HeadsetMicIcon: HeadsetMicIcon,
  SupportIcon: SupportIcon
};
const CustomIconButton = styled(IconButton)(({ theme }) => ({
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 120,
  minHeight: 100,
  height: "auto",
  padding: theme.spacing(1),
  "& .MuiSvgIcon-root": {
    fontSize: "3rem", // Увеличение размера иконки
  },
}));


const SimpleIconTextButton = ({ icon: IconComponent, text, onClick }) => {
  return (
    <CustomIconButton
      color="primary"
      sx={{
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      }}
      onClick={onClick}
    >
      <IconComponent />
      <Typography variant="body1" sx={{ mt: 0.5, fontSize: "0.75rem" }} color="CaptionText">
        {text}
      </Typography>
    </CustomIconButton>
  );
};
const PopoverIconTextButton = ({
  icon: IconComponent,
  text,
  onClick,
  element,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <CustomIconButton
        id="icon-button"
        color="primary"
        sx={{
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // добавление тени
          border: "1px solid rgba(0, 0, 0, 0.12)", // добавление бордера
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)", // изменение фона при наведении
          },
        }}
        onClick={handleClick}
      >
        <IconComponent />
        <Typography variant="body1" sx={{ mt: 0.5, fontSize: "0.75rem" }} color="CaptionText">
          {text}
        </Typography>
      </CustomIconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        aria-labelledby="icon-button"
      >
        <Box p={2}>
          {element}
        </Box>
      </Popover>
    </>
  );
};


const SubMenuWrapperDrawer = styled(Box)(
  ({ theme }) => `
    .MuiList-root {
      padding: 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr); /* Два элемента в строке */
      gap: 8px; /* Отступ между элементами */

      .MuiListItem-root {
        padding: 0;
        justify-content: center;
        display: flex;

        .MuiIconButton-root {
          display: flex;
          background-color: transparent;
          width: 58px;
          border-radius: ${theme.general.borderRadiusLg};
          height: 58px;
          justify-content: center;
          font-size: ${theme.typography.pxToRem(13)};
          padding: 0;
          position: relative;

          .name-wrapper {
            display: none;
            transition: ${theme.transitions.create(['color'])};
          }

          .MuiBadge-root {
            position: absolute;
            right: 8px;
            top: 12px;

            .MuiBadge-standard {
              background: ${theme.colors.alpha.white[70]};
              font-size: ${theme.typography.pxToRem(11)};
              font-weight: bold;
              text-transform: uppercase;
              color: ${theme.colors.alpha.black[100]};
            }
          }

          .MuiSvgIcon-root {
            transition: ${theme.transitions.create(['color'])};
            font-size: ${theme.typography.pxToRem(32)};
            color: ${theme.colors.alpha.trueWhite[70]};
          }

          &.active,
          &:hover {
            background-color: ${theme.colors.alpha.trueWhite[10]};

            .MuiSvgIcon-root {
              color: ${theme.colors.alpha.trueWhite[100]};
            }
          }
        }
      }
    }
  `
);

const renderNavigationMenuItemsDrawer = ({
  items,
  path
}: {
  items: MenuItem[];
  path: string;
}): JSX.Element => {
  // Filter items by name only if the path is "/bottom-navigation/doctordashboard"

  return (
    <SubMenuWrapperDrawer>
      <List component="div">
        {items.reduce((ev, item) => reduceChildRoutes({ ev, item, path }), [])}
      </List>
    </SubMenuWrapperDrawer>
  );
};


const renderNavigationMenuItems = ({
  items,
  path
}: {
  items: MenuItem[];
  path: string;
}): JSX.Element => {
  // Filter items by name only if the path is "/bottom-navigation/doctordashboard"

  return (
    <SubMenuWrapper>
      <List component="div">
        {items.reduce((ev, item) => reduceChildRoutes({ ev, item, path }), [])}
      </List>
    </SubMenuWrapper>
  );
};

const reduceChildRoutes = ({
  ev,
  path,
  item
}: {
  ev: JSX.Element[];
  path: string;
  item: MenuItem;
}): Array<JSX.Element> => {
  const key = uuidv4();

  const exactMatch = item.link
    ? !!matchPath(
      {
        path: item.link,
        end: true
      },
      path
    )
    : false;

  if (item.items) {
    const partialMatch = item.link
      ? !!matchPath(
        {
          path: item.link,
          end: false
        },
        path
      )
      : false;

    ev.push(

      <NavigationMenuItem
        active={partialMatch}
        open={partialMatch}
        name={item.name}
        icon={item.icon}
        link={item.link}
        badge={item.badge}
      >
        {renderNavigationMenuItems({
          path,
          items: item.items
        })}
      </NavigationMenuItem>
    );
  } else {
    ev.push(

      <NavigationMenuItem
        active={exactMatch}
        name={item.name}
        link={item.link}
        badge={item.badge}
        icon={item.icon}
      />
    );
  }

  return ev;
};

function NavigationMenu({ bottomref }: any) {
  const location = useLocation();
  const [menuItems, setMenuItems] = useState<MenuItems[]>([]);
  const [storedNavigation, setStoredNavigation] = useState<NavigationMenuGroup[]>([]);
  const [filteredNavigation, setFilteredNavigation] = useState<NavigationMenuGroup[]>([]);
  const navigation = useIconNavigation();
  const [token, setToken] = useState<string | null>();
  const { isAuth } = useAuthContext();
  const [openDrawer, setOpenDrawer] = useState(false);
  useEffect(() => {
    if (isAuth) {
      setToken(localStorage.getItem("accessToken"));
    }
  }, [isAuth])
  const apiUrl = REACT_APP_PORTAL_API_URL;
  const client = new Client(apiUrl);
  useEffect(() => {
    client.getavailablecomponents().then(components => {

      const items = components.map(component => ({
        name: component.name || 'Unnamed',
        link: component.url + `?t=${localStorage.getItem("accessToken") != undefined ? localStorage.getItem("accessToken") : ""}&redirectUrl=${window.location.href}` || '#',
        icon: iconMap[component.icon!]
      }));
      setMenuItems([{ heading: '', items: items }]);
    }).catch(error => {
      console.error('Error fetching menu items:', error);
    });
    setStoredNavigation(navigation.Navigation)
    setFilteredNavigation(navigation.Navigation);
  }, [isAuth, token]);

  useEffect(() => {
    setStoredNavigation(navigation.Navigation);
    setFilteredNavigation(navigation.Navigation);
  }, [navigation.Navigation])


  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleToggle = (event) => {
    setIsOpen(!isOpen);
    setAnchorEl(bottomref.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpen(false);
  };
  const theme = useTheme();
  const handleNavigationSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const filtered = storedNavigation.map(nav => {
      const copiedNav = { ...nav };
      copiedNav.items = copiedNav.items?.filter(item => {
        return item.name?.toLowerCase().includes(value.toLowerCase());
      });
      if (value != "") {
        copiedNav.id = 0;
      }
      return copiedNav;
    }).filter(nav => nav.items != null && nav.items.length > 0) as NavigationMenuGroup[];
    setFilteredNavigation(filtered);
  };


  return (
    <>
     <Box sx={{ display: { xs: "flex", md: "none" }, 
     justifyContent: "flex-end",alignItems:"center" }}>
        
        <MenuWrapper sx={{ mr: 1 }}>
          <List component="div">
            <Box>
              <IconButtonPrimary color="primary" onClick={handleToggle}>
                <img
                  style={{ height: 45, width: 45 }}
                  src="/static/images/logo/logo3.png"
                  alt="Company logo"
                />
                <Box sx={{ ml: -1 }}>
                  {!isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </Box>
              </IconButtonPrimary>
              <Popover
                BackdropProps={{
                  sx: {
                    backdropFilter: "blur(0px)",
                  },
                }}
                open={isOpen}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
                transformOrigin={{
                  vertical: 'bottom',
                  horizontal: 'center',
                }}
                sx={{
                  marginTop: "-5px",
                  marginBottom: "20px",
                }}
                PaperProps={{
                  sx: {
                    maxWidth: "50vw",
                    minWidth: "40vw",
                  },
                }}
              >
                <Box>

                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Autocomplete
                      freeSolo
                      sx={{ width: '30%' }}
                      id="search-input"
                      disableClearable
                      options={Array.from(new Set(storedNavigation.map(option => option.items).flat().map(option => option?.name)))}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Search"
                          margin="normal"
                          variant="outlined"
                          onChange={handleNavigationSearch}
                          onSelect={handleNavigationSearch}
                        />
                      )} />

                  </Box>
                  <Grid item xs={12} md={5}>
                    <Card
                      sx={{
                        position: "relative",
                        p: 2,
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 2,
                        flexWrap: "wrap",
                        justifyContent: "center",
                      }}

                    >
                      {
                        filteredNavigation?.filter(group => group.id == 0)?.map((group, groupIndex) => (
                          group.items?.filter(nav => nav.showInMenu)?.map((nav, navIndex) => (
                            <SimpleIconTextButton
                              key={`simpleButton-${groupIndex}-${navIndex}`} // Уникальный ключ
                              icon={nav.navigationItem?.reactIcon ? navigation.iconMap[nav.navigationItem?.reactIcon] : navigation.iconMap["None"]}
                              text={nav.name}
                              onClick={() => navigation.processNavigation(nav)}
                            />
                          ))
                        ))
                      }
                      {
                        filteredNavigation?.filter(group => group.id! > 0)?.map((group, groupIndex) => (
                          <PopoverIconTextButton
                            key={`popoverButton-${groupIndex}`} // Уникальный ключ
                            icon={FolderIcon}
                            text={group.name}
                            element={
                              <Box
                                sx={{
                                  background: "transparent",
                                  position: "relative",
                                  p: 2,
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                {
                                  group.items?.filter(nav => nav.showInMenu)?.map((nav, navIndex) => (
                                    <SimpleIconTextButton
                                      key={`popoverItem-${groupIndex}-${navIndex}`} // Уникальный ключ
                                      icon={nav.navigationItem?.reactIcon ? navigation.iconMap[nav.navigationItem?.reactIcon] : navigation.iconMap["None"]}
                                      text={nav.name}
                                      onClick={() => navigation.processNavigation(nav)}
                                    />
                                  ))
                                }
                              </Box>
                            }
                          />
                        ))
                      }
                    </Card>
                  </Grid>


                  <Divider />

                </Box>
                {
                  navigation.RecentlyNavigation.length > 0 ?
                    (
                      <Grid item xs={12} md={5}>
                        {
                          navigation.RecentlyNavigation.length > 0 ?
                            (<Box sx={{ textAlign: 'center' }}>
                              <Typography
                                sx={{
                                  pt: 1,
                                }}
                                variant="h4"
                              >
                                {t("Recently viewed")}
                              </Typography>

                            </Box>) : null
                        }
                        <Card
                          sx={{
                            position: "relative",
                            p: 2,
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 2,
                            justifyContent: "center",
                            flexWrap: "wrap",
                          }}

                        >
                          <>

                            {
                              navigation.RecentlyNavigation?.filter(nav => nav.showOnDashboard)?.map((nav,index) => (
                                <>
                                  <SimpleIconTextButton
                                  key={`simple-${index}`}
                                    icon={nav.navigationItem?.reactIcon ? navigation.iconMap[nav.navigationItem?.reactIcon] : navigation.iconMap["None"]}
                                    text={nav.name}
                                    onClick={() => navigation.processNavigation(nav)}
                                  />
                                </>
                              ))
                            }
                          </>

                        </Card>
                        <Divider />

                      </Grid>


                    ) : null
                }


              </Popover>
            </Box>
          </List>
        </MenuWrapper>
        <MobileMenuButton onClick={() => setOpenDrawer(true)}>
          <MenuIcon />
        </MobileMenuButton>
        
      </Box>
      
      <Box sx={{
      display: { xs: "none", md: "flex" },
        justifyContent: "center"
      }}>
     
        {localStorage.getItem("accessToken")
          && menuItems.map((section,key) => (
            <MenuWrapper key={key}>
              <List component="div">
                {renderNavigationMenuItems({
                  items: section.items,
                  path: location.pathname + `?t=${localStorage.getItem("accessToken")}&redirectUrl=${window.location.href}`
                })}
              </List>
            </MenuWrapper>
          ))}
      </Box>
      <DrawerWrapper anchor="left" open={openDrawer} onClose={() => setOpenDrawer(false)}>
        <Box sx={{ p: 2 }}>
        {localStorage.getItem("accessToken")
          && menuItems.map((section,key) => (
            <MenuWrapper key={key}>
              <List component="div">
                {renderNavigationMenuItemsDrawer({
                  items: section.items,
                  path: location.pathname + `?t=${localStorage.getItem("accessToken")}&redirectUrl=${window.location.href}`
                })}
              </List>
            </MenuWrapper>
          ))}

       
        </Box>
      </DrawerWrapper>
    </>
  );
}

export default NavigationMenu;
